import './App.css';
import LinkerGroup from './components/linker-group';

function App() {
  return (
    <div className="App">
      <LinkerGroup></LinkerGroup>
    </div>
  );
}

export default App;
